export const pricelistList = (state, rootState) => {
	return state.pricelistList;
}

export const pricelistEdit = (state, rootState) => {
	return state.pricelistEdit;
}

export const priceTableAll = (state, rootState) => {
	return state.priceTableAll;
}

export const priceTableAllSelected = (state, rootState) => {
	return state.priceTableAllSelected;
}

export const priceTableList = (state, rootState) => {
	return state.priceTableList;
}

export const priceTableDetails = (state, rootState) => {
	return state.priceTableDetails;
}

export const priceTableListFirst = (state, rootState) => {
	return state.priceTableListFirst;
}

export const isLibraryUpdate = (state, rootState) => {
	return state.isLibraryUpdate;
}

export const libraryDetails = (state, rootState) => {
	return state.libraryDetails;
}

export const libraryLoading = (state, rootState) => {
	return state.libraryLoading;
}

export const importingData = (state, rootState) => {
  return state.importingData;
}
